/** How an attachment too large for the model's context is handled: cut to fit, or summarized first. */
const ATTACHMENT_OVERFLOW_STRATEGY = Object.freeze({
  truncate: 'truncate',
  summarize: 'summarize'
});

export default ATTACHMENT_OVERFLOW_STRATEGY;
